/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Gl_11_DInputs */

const en_tut_gl_11_d = /** @type {(inputs: Tut_Gl_11_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A desk with a 3 × 3 tile quiet zone: nearby audio, nearby chat, and reactions are off for anyone passing through.`)
};

const id_tut_gl_11_d = /** @type {(inputs: Tut_Gl_11_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meja dengan zona tenang 3 × 3 petak: audio sekitar, chat sekitar, dan reaksi mati bagi siapa pun yang melintas.`)
};

/**
* | output |
* | --- |
* | "A desk with a 3 × 3 tile quiet zone: nearby audio, nearby chat, and reactions are off for anyone passing through." |
*
* @param {Tut_Gl_11_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_gl_11_d = /** @type {((inputs?: Tut_Gl_11_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Gl_11_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_gl_11_d(inputs)
	return en_tut_gl_11_d(inputs)
});